import { INTENT_TYPE } from '../../constants';
import { SHORT_QUERY_MAX_WORDS } from '../pack/constants';
import { type ConvergenceRule, type FeatureContext } from '../types';

/**
 * `S-SHORT` (priority 920) — one or two words with nothing else to go on.
 *
 * A fallback, not a classification, which is why it sits below every semantic
 * grammar. One or two words is how people search; it is not how they ask.
 *
 * The predicate counts tokens and nothing else, so it would happily claim `SEO?`.
 * `C-TERMINAL-QUESTION` sits immediately above it and takes the question-marked cases
 * first — position is what keeps a short question out of Search, not a guard here.
 *
 * Zero tokens belongs to `S-EMPTY`, which runs first.
 */
export const isShortQuery = (features: FeatureContext): boolean => {
	const tokenCount = features.wordTokens.length;

	return tokenCount > 0 && tokenCount <= SHORT_QUERY_MAX_WORDS;
};

export const shortRule: ConvergenceRule = {
	type: INTENT_TYPE.FPS,
	pattern: 'SHORT_QUERY',
	matches: isShortQuery,
};
